// Расчёт, начатый на лендинге: после входа (и создания компании) подставляется
// в калькулятор сервиса. Отдельный модуль, чтобы вход и экран компании не тянули калькулятор.
const PENDING_PUBLIC_CALC_KEY = "uprosti:pendingUnitCalc";
const PENDING_PUBLIC_CALC_TTL_MS = 7 * 24 * 60 * 60 * 1000;

export function readPendingPublicCalc(marketplace) {
  try {
    const raw = window.localStorage.getItem(PENDING_PUBLIC_CALC_KEY);
    if (!raw) return null;
    const pending = JSON.parse(raw);
    if (!pending || pending.marketplace !== marketplace) return null;
    if (Date.now() - Number(pending.savedAt || 0) > PENDING_PUBLIC_CALC_TTL_MS) {
      window.localStorage.removeItem(PENDING_PUBLIC_CALC_KEY);
      return null;
    }
    return pending;
  } catch (_error) {
    return null;
  }
}

export function writePendingPublicCalc(marketplace, input) {
  try {
    window.localStorage.setItem(PENDING_PUBLIC_CALC_KEY, JSON.stringify({ marketplace, input, savedAt: Date.now() }));
  } catch (_error) {
    // Без localStorage расчёт просто не перенесётся в сервис.
  }
}

export function clearPendingPublicCalc() {
  try {
    window.localStorage.removeItem(PENDING_PUBLIC_CALC_KEY);
  } catch (_error) {
    // ignore
  }
}

// Лендинг запоминает расчёт перед входом.
export function rememberPublicCalculation(marketplace, input) {
  writePendingPublicCalc(marketplace, input);
}

// Куда вести после входа или создания компании, если с сайта ждёт расчёт ("" — не ждёт).
export function getPendingPublicCalcPath() {
  const pending = readPendingPublicCalc("ozon") || readPendingPublicCalc("wb");
  if (!pending) return "";
  return pending.marketplace === "wb" ? "/wildberries/planUnit" : "/ozon/planUnit";
}
